import type { APIError } from "@/types/api.types";
import type { FieldErrors } from "@/types/authState.types";

export function isAPIError(value: unknown): value is APIError {
  if (value == null || typeof value !== "object") return false;
  const valMessage = value as { message?: unknown };
  return typeof valMessage.message === "string";
}

export function isFieldErrors(obj: unknown): obj is FieldErrors {
  if (obj == null || typeof obj !== "object" || Array.isArray(obj)) return false;
  const rec = obj;
  return Object.values(rec).every(
    (value): value is string | undefined => typeof value === "string" || typeof value === "undefined"
  );
}

export const hasFieldErrors = (field: unknown): field is { fieldErrors: unknown } =>
  field != null && typeof field === "object" && "fieldErrors" in field;

export function getErrorsFromPayload(
  payload: unknown,                       // <- allow string/null/etc.
  actionErrorMessage?: string
): { fieldErrors: FieldErrors; error?: string } {
  let fieldErrors: FieldErrors = {};
  let error: string | undefined = undefined;

  if (hasFieldErrors(payload)) {
    const { fieldErrors: rawFieldErrors} = payload as { fieldErrors: unknown }

    if (typeof rawFieldErrors === "string") {
      error = rawFieldErrors; // form-level message
    } else if (isFieldErrors(rawFieldErrors)) {
      fieldErrors = rawFieldErrors; // per-field map (string | undefined)
    } else if (Array.isArray(rawFieldErrors)) {
      error = rawFieldErrors.filter(Boolean).join(", ");
    }
  } else if (typeof payload === "string") {
    error = payload;
  }

  if (error == null && (actionErrorMessage !== undefined)) {
    error = actionErrorMessage;
  }

  return { fieldErrors, error };
}
